/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import CN from 'classnames';
import { Button, Input, SimpleSelect } from 'components/atoms';
import { Loader } from 'components/atoms/Loader';
import {
  useAddVideoToRemoveBucket,
  useDeleteVRVideoByID,
  useGetAllEnterpriseRemovedVideos,
  useGetAllEnterprises,
  useGetAllEnterpriseVideos,
  useGetAllVideos,
  useGetAllVideosForMontization,
  useRemoveVideoToRemoveBucket,
  useUpdateVideoMonetizeStatus,
  useUpdateVideoStatus,
} from 'framework/api/methods';
import React, { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useDebounce from 'utils/debounce';

export interface AllocatedVideoProps {
  [x: string]: any;
}

export const AllocatedVideo: FC<AllocatedVideoProps> = () => {
  const navigate = useNavigate();

  const notify = (message: any, type: any) => {
    if (type === 'error') {
      toast.error(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'bottom-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const [selectedState, setSelectedState] = useState({
    label: 'Selected',
    value: 'selected',
  });

  const [searchText, setSearchText] = useState('');

  const [videoList, setVideoList] = useState([]);

  const [enterprisesList, setEnterprisesList] = useState([]);
  const [selectedEnterprise, setSelectedEnterprise] = useState<any>({
    enterprise_id: '',
    enterprise_name: '',
  });

  const { mutate: getAllVideosMutate, isLoading: getAllVideosIsLoading } =
    useGetAllEnterpriseVideos();

  const { mutate: getAllEnterprisesMutate } = useGetAllEnterprises();
  const { mutate: addVideoToRemoveBucketMutate, isLoading: addVideoToRemoveBucketIsLoading } =
    useAddVideoToRemoveBucket();

  const { mutate: removeVideoToRemoveBucketMutate, isLoading: removeVideoToRemoveBucketIsLoading } =
    useRemoveVideoToRemoveBucket();

  const [uncheckedVideoIds, setUncheckedVideoIds] = useState<string[]>([]);

  const handleCheckboxChange = (videoId: string) => {
    setUncheckedVideoIds(
      (prev) =>
        prev.includes(videoId)
          ? prev.filter((id) => id !== videoId) // if already unchecked, re-check it
          : [...prev, videoId], // add to unchecked list
    );
  };

  const isChecked = (videoId: string) => !uncheckedVideoIds.includes(videoId);

  const getAllEnterprises = () => {
    getAllEnterprisesMutate(
      {
        search: 'All',
      },
      {
        onSuccess: ({ data: successData }: any) => {
          const list = successData?.enterprises || [];
          setEnterprisesList(list);
          if (list.length > 0) {
            setSelectedEnterprise(list[0]);
          }
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setEnterprisesList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            // notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  useEffect(() => {
    getAllEnterprises();
  }, []);

  const {
    mutate: getAllEnterpriseRemovedVideosMutate,
    isLoading: getAllEnterpriseRemovedVideosIsLoading,
  } = useGetAllEnterpriseRemovedVideos();

  const getAllVideos = () => {
    getAllVideosMutate(
      {
        id: selectedEnterprise.enterprise_id || '',
        search: searchText === '' ? 'All' : searchText,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setVideoList(successData.videos || []);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setVideoList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const getAllEnterpriseRemovedVideos = () => {
    getAllEnterpriseRemovedVideosMutate(
      {
        id: selectedEnterprise.enterprise_id || '',
        search: searchText === '' ? 'All' : searchText,
      },
      {
        onSuccess: ({ data: successData }: any) => {
          setVideoList(successData.removedVideos || []);
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setVideoList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const debouncedSearchText = useDebounce(searchText, 500);

  useEffect(() => {
    if (selectedEnterprise.enterprise_id) {
      if (selectedState.value === 'removed') {
        getAllEnterpriseRemovedVideos();
      } else {
        getAllVideos();
      }
    }
  }, [debouncedSearchText, selectedEnterprise.enterprise_id]);

  const addVideoToRemoveBucket = () => {
    addVideoToRemoveBucketMutate(
      {
        id: selectedEnterprise.enterprise_id,
        vid: uncheckedVideoIds || [],
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData?.message || 'List updated successfully.', 'success');
          getAllVideos();
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setEnterprisesList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            // notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const removeVideoToRemoveBucket = () => {
    removeVideoToRemoveBucketMutate(
      {
        id: selectedEnterprise.enterprise_id,
        vid: uncheckedVideoIds || [],
      },
      {
        onSuccess: ({ data: successData }: any) => {
          notify(successData?.message || 'List updated successfully.', 'success');
          getAllEnterpriseRemovedVideos();
        },
        onError: ({ response: { data: errData }, response }: any) => {
          setEnterprisesList([]);
          if (response?.status === 405 || response?.status === 403 || response?.status === 501) {
            notify('Session expired.', 'error');
            setTimeout(() => {
              navigate('/auth/login');
              localStorage.clear();
            }, 2000);
          } else {
            // notify(errData?.message || 'Something went wrong.', 'error');
          }
        },
      },
    );
  };

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;

    if (mins > 0 && secs > 0) {
      return `${mins.toString().padStart(2, '0')} min ${secs.toString().padStart(2, '0')} sec`;
    }
    if (mins > 0) {
      return `${mins.toString().padStart(2, '0')} min`;
    }
    return `${secs.toString().padStart(2, '0')} sec`;
  };

  return (
    <div className="flex w-full h-full py-6 px-8 gap-x-2">
      <div className="w-1/5 pt-2 gap-y-2 flex flex-col">
        <div className="bg-[#C40D42] text-white rounded text-base font-medium px-6 py-1 w-fit">
          Enterprises
        </div>
        <div className="h-full overflow-y-auto flex flex-col gap-y-2">
          {enterprisesList.map((enterprise: any, index: number) => (
            <div
              key={index}
              className={CN(
                'cursor-pointer px-4 py-3 text-sm text-[#63717A] border-b border-b-[#737a7e80] capitalize',
                selectedEnterprise?.enterprise_id === enterprise.enterprise_id
                  ? 'bg-[#ECECEC] font-semibold'
                  : 'bg-[white] ',
              )}
              onClick={() => {
                setSelectedEnterprise(enterprise);
              }}
            >
              {enterprise?.enterprise_name}
            </div>
          ))}
        </div>
      </div>
      <div className="w-4/5 flex flex-col h-full">
        <div className="flex justify-between items-center">
          <div className="w-1/3">
            <div className="w-[180px] bg-[#f7951e24]">
              <SimpleSelect
                isSearchable={false}
                value={selectedState}
                options={[
                  {
                    label: 'Selected',
                    value: 'selected',
                  },
                  {
                    label: 'Removed',
                    value: 'removed',
                  },
                ]}
                onChange={(e: any) => {
                  setSelectedState(e);
                  setUncheckedVideoIds([]);

                  if (e.value === 'removed') {
                    getAllEnterpriseRemovedVideos();
                  } else {
                    getAllVideos();
                  }
                }}
              />
            </div>
          </div>

          <div className="w-2/3 flex justify-between items-start gap-x-5">
            <Input
              icon="ri-search-line !text-[#C40D42] font-semibold"
              value={searchText}
              placeholder="Search here..."
              className="!w-[400px]"
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
            />

            <Button
              onClick={() => {
                if (selectedState.value === 'selected') {
                  addVideoToRemoveBucket();
                } else {
                  removeVideoToRemoveBucket();
                }
              }}
              disabled={uncheckedVideoIds?.length === 0}
              isRounded
              size="sm"
            >
              <i className="ri-add-line pr-1" />
              Confirm
            </Button>
          </div>
        </div>

        <div className="h-full overflow-y-auto w-full mt-5">
          {(getAllVideosIsLoading ||
            getAllEnterpriseRemovedVideosIsLoading ||
            addVideoToRemoveBucketIsLoading ||
            removeVideoToRemoveBucketIsLoading) && <Loader appearance="black" className="mt-5" />}

          {!(
            getAllVideosIsLoading ||
            getAllEnterpriseRemovedVideosIsLoading ||
            addVideoToRemoveBucketIsLoading ||
            removeVideoToRemoveBucketIsLoading
          ) &&
            videoList?.length === 0 && (
              <div className="mt-5 text-sm text-center w-full text-neutral-500">
                No videos found.
              </div>
            )}
          {!(
            getAllVideosIsLoading ||
            getAllEnterpriseRemovedVideosIsLoading ||
            addVideoToRemoveBucketIsLoading ||
            removeVideoToRemoveBucketIsLoading
          ) &&
            videoList?.map((video: any, index) => (
              <div className="p-3 flex bg-white rounded w-full h-fit mt-2" key={index}>
                <div className="flex h-[100px] gap-x-2 overflow-x-auto justify-between items-start w-full">
                  <div className="flex w-1/3 gap-x-2 h-full">
                    <img
                      src={video?.cover_image_url}
                      alt="img-video"
                      className="h-[100px] w-[180px] object-cover rounded"
                    />

                    <div className="flex flex-col h-full w-fit justify-between items-start">
                      <div className="text-sm font-medium text-[#63717A] max-w-[400px] h-full max-h-[70px] overflow-y-auto">
                        {video?.title || ''}
                      </div>

                      <div className="flex gap-x-1">
                        <i className="ri-eye-fill text-[#d3a5b2] text-[20px] leading-6" />
                        <div className="text-[14px] leading-6 text-[#63717A]">
                          {video?.view_count || 0}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={CN(
                      'bg-[#EFEFEF] flex flex-col p-3 gap-x-2 w-[calc(66%-25px)] h-full rounded-md',
                    )}
                  >
                    <div className="flex w-full gap-x-3 flex-wrap gap-y-2">
                      <div className="flex gap-x-2 justify-center items-center">
                        <span className="text-xs min-w-[59px]">Published</span>
                        <div className="text-xs bg-white  px-2 py-1 min-w-[145px] rounded text-[#63717A] !h-[24px]">
                          {video?.created_at
                            ? new Date(video.created_at)
                                .toLocaleString('en-US', {
                                  month: 'short',
                                  day: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  hour12: true,
                                  timeZone: 'UTC',
                                })
                                .replace(',', '')
                            : ''}
                        </div>
                      </div>

                      <div className="flex gap-x-2 justify-center items-center">
                        <span className="text-xs min-w-[59px]">Category</span>
                        <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                          {video?.category || ''}
                        </div>
                      </div>

                      <div className="flex gap-x-2 justify-center items-center">
                        <span className="text-xs">Length</span>
                        <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                          {formatTime(video.length_seconds) || ''}
                        </div>
                      </div>

                      <div className="flex gap-x-2 justify-center items-center">
                        <span className="text-xs min-w-[59px]">Monetize</span>
                        <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                          {video?.monetization_status ? 'On' : 'Off'}
                        </div>
                      </div>

                      <div className="flex gap-x-2 justify-center items-center">
                        <span className="text-xs min-w-[78px]">Uploaded By</span>
                        <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                          {video?.uploaded_by || ''}
                        </div>
                      </div>

                      <div className="flex gap-x-2 justify-center items-center">
                        <span className="text-xs min-w-[50px]">Video Id</span>
                        <div className="text-xs bg-white  px-2 py-1 min-w-fit w-full rounded text-[#63717A] !h-[24px]">
                          {video?.vid || ''}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col gap-y-3 font-thin h-full justify-start items-start w-[24px]">
                    <input
                      type="checkbox"
                      checked={isChecked(video?.vid)}
                      onChange={() => handleCheckboxChange(video?.vid)}
                      className="w-4 h-4 cursor-pointer appearance-none rounded border border-[#C40D42] checked:bg-[#C40D42] checked:border-[#C40D42] checked:text-white text-transparent flex items-center justify-center text-sm font-bold
    before:content-['✓'] before:opacity-0 checked:before:opacity-100 before:text-white before:text-xs before:flex before:items-center before:justify-center before:h-full before:w-full before:leading-none"
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default AllocatedVideo;
